import { render, staticRenderFns } from "./DemandeModificationSociete.vue?vue&type=template&id=06327002"
import script from "./DemandeModificationSociete.vue?vue&type=script&lang=js"
export * from "./DemandeModificationSociete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports